/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_endpoint",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "msgValue",
                type: "uint256",
            },
        ],
        name: "ReceivedMessage",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "VERIFIED_MASK_INDEX",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "authorizedHook",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "endpoint",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "isVerified",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "srcEid",
                        type: "uint32",
                    },
                    {
                        internalType: "bytes32",
                        name: "sender",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "nonce",
                        type: "uint64",
                    },
                ],
                internalType: "struct Origin",
                name: "",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_lzMessage",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "lzReceive",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "moduleType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "messageId",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "msgValue",
                type: "uint256",
            },
        ],
        name: "preVerifyMessage",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "releaseValueToRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_hook",
                type: "bytes32",
            },
        ],
        name: "setAuthorizedHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "verifiedMessages",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class LayerZeroV2Ism__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_endpoint, overrides) {
        return super.deploy(_endpoint, overrides || {});
    }
    getDeployTransaction(_endpoint, overrides) {
        return super.getDeployTransaction(_endpoint, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=LayerZeroV2Ism__factory.js.map